import UniversityProgram from './university-program'
import UniversityProgramPageQuery, { UNIVERSITY_PROGRAM_QUERY } from './university-program.query'

export { UniversityProgramPageQuery, UNIVERSITY_PROGRAM_QUERY }

export default UniversityProgram
